'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export default function GTMPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const url = `${pathname}${searchParams ? `?${searchParams.toString()}` : ''}`;

    // GTM にページビューイベントを送信
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'pageview', // カスタムイベント名
        page: url, // ページのURL
      });
    }
  }, [pathname, searchParams]); // URLの変更を検知

  return null; // このコンポーネントは UI をレンダリングしません
}
